module.exports = __webpack_public_path__ + "static/media/banner.66d4776a.png";